<template>
    <v-list>
        <v-list-item
            v-for="(language, languageIndex) of availableLanguageList"
            :key="`Language-${languageIndex}`"
            @click.prevent="setLanguage(language)"
        >
            <v-list-item-title class="text-capitalize text-start">
                {{ language.text }}
            </v-list-item-title>
        </v-list-item>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'LanguageSettingsItems',
        data() {
            return {
                languageList: [
                    {
                        'id': 'fr',
                        'text': 'Français'
                    },
                    {
                        'id': 'en',
                        'text': 'English'
                    },
                    {
                        'id': 'es',
                        'text': 'Español'
                    },
                    {
                        'id': 'ca',
                        'text': 'Catalán'
                    },
                    {
                        'id': 'it',
                        'text': 'Italiano'
                    },
                    {
                        'id': 'pt',
                        'text': 'Português'
                    }
                ]
            }
        },
        props: {
            language: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapGetters([
                'isLocalstorageAvailable'
            ]),
            languageKey() {
                return 'language-' + this.$route.query.key;
            },
            availableLanguageList() {
                return this.languageList.filter(lang => lang.id !== this.language);
            }
        },
        methods: {
            setLanguage(language) {
                if (this.isLocalstorageAvailable)
                    localStorage.setItem(this.languageKey, language.id);
                let redirectUrl = new URL(window.location.href);
                redirectUrl.searchParams.set('language', language.id);
                window.location.href = redirectUrl.href;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/threeDController/components/LanguageSettingsItems.vue